import React, { Fragment, useState, useMemo, memo, useEffect } from "react";
import { getTranslation } from "orion-components/i18n";
import Divider from "./Divider";
import { getEntityIconsByGroup } from "orion-components/GlobalData/Selectors";
import { useSelector } from "react-redux";
import SpriteIcon from "orion-components/SharedComponents/SpriteIcon/SpriteIcon";

const IconsWrapper = ({ handleIconClick, frameIcons, pickedIcon, pickedGroup }) => {
	const icons = useSelector((state) => frameIcons ?? getEntityIconsByGroup(state)("frame_icons", "group"));
	return (
		<IconsWidget
			icons={icons}
			handleIconClick={handleIconClick}
			pickedIcon={pickedIcon}
			pickedGroup={pickedGroup}
		/>
	);
};

const IconsWidget = memo(
	({ icons, handleIconClick, pickedIcon, pickedGroup }) => {
		const [selectedTitle, setSelectedTitle] = useState("");
		const [selectedIcon, setSelectedIcon] = useState("");

		useEffect(() => {
			if (pickedIcon !== "") {
				setSelectedIcon(pickedIcon);
				setSelectedTitle(pickedGroup);
			}
		}, [pickedIcon, pickedGroup]);

		const renderedData = useMemo(() => {
			return Object.entries(icons).map(([key, value], index) => {
				const title = getTranslation(
					"global.sharedComponents.shapeEditor.components.pointEditor.components.symbolSelector.symbols." + key
				);
				return (
					<Fragment key={index}>
						<div style={{ color: "#fff", fontSize: 10, marginTop: 15 }}>{title}</div>
						<div style={{ display: "flex", flexWrap: "wrap", margin: "8px 0px" }}>
							{value.map((obj, idx) => (
								<div
									style={{
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										padding: 2,
										borderRadius: 2,
										cursor: "pointer"
									}}
									key={idx}
								>
									<div
										className="entity-icon-wrapper"
										onClick={() => {
											setSelectedIcon(obj.id);
											setSelectedTitle(key);
											handleIconClick(key, obj.id);
										}}
										style={{
											backgroundColor:
												selectedTitle == key && selectedIcon === obj.id ? "#37383B" : null,
											border:
												selectedTitle == key && selectedIcon === obj.id
													? "1px solid #fff"
													: null,
											padding: 5,
											display: "flex",
											alignItems: "center",
											justifyContent: "center"
										}}
										x-asc-atf-id={obj.id}
										x-asc-atf-class="event-type-icon"
									>
										<SpriteIcon
											iconName={obj?.id ?? "icon_information"}
											customHeight="30px"
											customWidth="30px"
											customStyles={{ maxWidth: "100%", maxHeight: "100%" }}
										/>
									</div>
								</div>
							))}
						</div>
						{index !== Object.keys(icons).length - 1 ? <Divider /> : null}
					</Fragment>
				);
			});
		}, [icons, selectedTitle, selectedIcon]);

		return <Fragment>{renderedData}</Fragment>;
	},
	(prevProps, nextProps) => {
		return Object.keys(prevProps.icons).length === Object.keys(nextProps.icons).length;
	}
);
IconsWidget.displayName = "IconsWidget";

export default IconsWrapper;
